import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';
import { useIsActingAsSystemAdmin } from './useIsActingAsSystemAdmin';
import type { PlatformTenant } from '@/components/TenantSwitcher';

/** v1.0 Phase1-5最終監査 MEDIUM対応 (design書R-3残存リスク): システム管理者が他テナントを操作中の
 *  バナー・破壊的操作確認ダイアログのいずれも「他テナント」としか表示せず、具体的にどのテナントかが
 *  分からなかった (誤操作防止のための3重ルールのうち「テナント名の可視化」が欠けていた)。
 *  TenantSwitcher.tsx と同じ queryKey (['platform','tenants']) を使うため、いずれかが先にマウント
 *  されていればキャッシュを共有し追加リクエストは発生しない。isActing=false の間は問い合わせない。 */
export function useActiveTenantDisplayName(): string | null {
  const user = useAuthStore((s) => s.user);
  const isActing = useIsActingAsSystemAdmin();

  const { data } = useQuery<{ tenants: PlatformTenant[] }>({
    queryKey: ['platform', 'tenants'],
    queryFn: () => apiFetch('/platform/tenants'),
    enabled: isActing,
    staleTime: 60 * 1000,
  });

  if (!isActing) return null;
  return data?.tenants.find((t) => t.tenant_id === user?.active_tenant_id)?.display_name ?? null;
}
